export default __webpack_public_path__ + "assets/0c8a5d21-8a14-4451-8145-695071809cb7-hebrew.woff2";